import React, {useEffect} from 'react';
//import './Home.css';

export const Home = () => {
	useEffect(() => {
		document.title = `e-Kontrole | Witamy w aplikacji e-Kontrole`;
		return () => {
			document.title = `e-Kontrole`;
		}
	}, []);

	return (<div id='home'>
		<h2 className='text-center mb-5'>Witamy w aplikacji e-Kontrole</h2>
		<p className='h5 mt-5 mb-4'>Aplikacja e-Kontrole wspiera:</p>
		<ul className='h5'>
			<li className='mb-3'>zarządzanie procesami kontroli</li>
			<li className='mb-3'>prowadzenie i dokumentowanie kontroli</li>
			<li className='mb-3'>sporządzanie informacji pokontrolnej</li>
		</ul>
	</div>);
};


